import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";

// page for all routes that are currently being developed 
const SubscribeToResourcePage = () => {
    return (
        <div class='summary-page'>
            <HeaderBanner />
            <br/>
            <h1 style={{textAlign: 'center'}}>Please subscribe to this resource to view the page</h1>
            <br/>
            <Footer cssClassName="footer-main-comp"/>
        </div>
    );
}

export default SubscribeToResourcePage; 